var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['button', _vm.classType, _vm.className, _vm.smallSize ? 'small-btn' : ''],attrs:{"type":[_vm.type],"disabled":_vm.disabled},on:{"click":_vm.doAction}},[(_vm.srcSvg)?_c('inline-svg',{class:[_vm.isReverseIcon ? 'reverse' : '', _vm.svgClass],attrs:{"src":_vm.srcSvg}}):_vm._e(),(_vm.title)?_c('span',{class:[
      'button-content',
      _vm.srcSvg && 'icon',
      _vm.isReverseIcon && 'content-reverse',
      _vm.hasBorder && 'hover-class',
      _vm.isBack && 'back-button-content'
    ]},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }